import { jsx as _jsx } from "preact/jsx-runtime";
export function CalendarTheme() {
    return (_jsx("style", { children: `
      /* Light mode - use slate backgrounds and OrbitalX green for primary */
      .sx__calendar-wrapper {
        --sx-color-primary: #52de45;
        --sx-color-on-primary: #ffffff;
        --sx-color-primary-container: #dcfce7;
        --sx-color-on-primary-container: #15803d;
        
        /* Main background color - affects all views */
        --sx-color-background: #ffffff;
        --sx-color-on-background: #0f172a;
        
        /* Surface colors for cards and containers */
        --sx-color-surface: #ffffff;
        --sx-color-surface-variant: #f8fafc;
        --sx-color-surface-container: #f8fafc;
        --sx-color-surface-container-low: #f1f5f9;
        --sx-color-surface-container-high: #e2e8f0;
        --sx-color-on-surface: #0f172a;
        --sx-color-on-surface-variant: #475569;
        
        /* Borders */
        --sx-color-outline: #e2e8f0;
        --sx-color-outline-variant: #cbd5e1;
      }
      
      /* Dark mode - use slate dark backgrounds and lighter green */
      .sx__calendar-wrapper.is-dark {
        --sx-color-primary: #4ade80;
        --sx-color-on-primary: #052e16;
        --sx-color-primary-container: #166534;
        --sx-color-on-primary-container: #86efac;
        
        /* Main background color - affects all views */
        --sx-color-background: #1e293b;
        --sx-color-on-background: #f1f5f9;
        
        /* Surface colors for cards and containers */
        --sx-color-surface: #1e293b;
        --sx-color-surface-variant: #334155;
        --sx-color-surface-container: #334155;
        --sx-color-surface-container-low: #0f172a;
        --sx-color-surface-container-high: #475569;
        --sx-color-on-surface: #f1f5f9;
        --sx-color-on-surface-variant: #cbd5e1;
        
        /* Borders */
        --sx-color-outline: #475569;
        --sx-color-outline-variant: #334155;
      }
      
      /* Force background colors on elements - Light mode */
      .sx__calendar-wrapper {
        background-color: #ffffff !important;
      }
      
      .sx__calendar-wrapper .sx__calendar,
      .sx__calendar-wrapper .sx__view-container,
      .sx__calendar-wrapper .sx__week-grid,
      .sx__calendar-wrapper .sx__time-grid-day {
        background-color: #ffffff !important;
      }
      
      /* Force background colors on elements - Dark mode */
      .sx__calendar-wrapper.is-dark {
        background-color: #1e293b !important;
      }
      
      .sx__calendar-wrapper.is-dark .sx__calendar,
      .sx__calendar-wrapper.is-dark .sx__view-container,
      .sx__calendar-wrapper.is-dark .sx__week-grid,
      .sx__calendar-wrapper.is-dark .sx__time-grid-day {
        background-color: #1e293b !important;
      }
      
      /* Make resize handles larger and easier to grab */
      .sx__time-grid-event-resize-handle {
        height: 12px !important;
        background: transparent !important;
        cursor: ns-resize !important;
        bottom: -6px !important;
        z-index: 10 !important;
      }

      .sx__time-grid-event-resize-handle::after {
        content: '';
        position: absolute;
        bottom: 6px;
        left: 50%;
        transform: translateX(-50%);
        width: 30px;
        height: 3px;
        background-color: currentColor;
        opacity: 0.5;
        border-radius: 2px;
      }

      .sx__time-grid-event-resize-handle:hover::after {
        opacity: 0.8;
        height: 4px;
      }

      .sx__date-grid-event-resize-handle {
        width: 12px !important;
        background: transparent !important;
        cursor: ew-resize !important;
        right: -6px !important;
        z-index: 10 !important;
      }

      .sx__date-grid-event-resize-handle::after {
        content: '';
        position: absolute;
        right: 6px;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 30px;
        background-color: currentColor;
        opacity: 0.5;
        border-radius: 2px;
      }

      .sx__date-grid-event-resize-handle:hover::after {
        opacity: 0.8;
        width: 4px;
      }

      /* Larger touch targets on touch devices */
      @media (pointer: coarse) {
        .sx__time-grid-event-resize-handle {
          height: 24px !important;
          bottom: -12px !important;
        }
        .sx__time-grid-event-resize-handle::after {
          bottom: 12px;
          width: 40px;
          height: 4px;
        }
        .sx__date-grid-event-resize-handle {
          width: 24px !important;
          right: -12px !important;
        }
        .sx__date-grid-event-resize-handle::after {
          right: 12px;
          height: 40px;
          width: 4px;
        }
      }
    ` }));
}
